import { AxiosError } from 'axios';

import { STAGE_PROMPTS_API_URL } from '@/constants/apis';
import { apiManager } from '@/helpers/api.manager';
import { StagePrompt } from '@/types/general-settings/stage.prompt.type';
import { ApiResponse } from '@/types/response.type';

export const getStagePrompts = async (): Promise<
  ApiResponse<StagePrompt[]>
> => {
  try {
    const response = await apiManager.get(STAGE_PROMPTS_API_URL, {
      headers: { 'Content-Type': 'application/json' },
    });

    if (response.status !== 200) {
      const error = response as unknown as AxiosError;
      return Promise.reject(error.response?.data);
    }

    return Promise.resolve(response.data);
  } catch (e) {
    return Promise.reject(e);
  }
};
